import { FIELD_TYPES } from '../constants';
export const hasMultilineAddress = (form)=>{
    return Boolean([
        ...form?.fields || [],
        ...form?.deletedFields || []
    ].some((field)=>field.view?.fieldType === FIELD_TYPES.MULTILINE_ADDRESS || field.view?.fieldType === FIELD_TYPES.BOOKINGS_ADDRESS));
};
export const isMultilineAddressField = (field)=>field.view?.fieldType === FIELD_TYPES.MULTILINE_ADDRESS || field.view?.fieldType === FIELD_TYPES.BOOKINGS_ADDRESS;

//# sourceMappingURL=multiline-address.js.map